// @ts-ignore: no types exist for this package, but we export the typed function properly
import _inject from 'style-inject';
export const styleInject: (
  css: string,
  opts?: { insertAt?: 'top' | 'bottom' }
) => void = _inject;
